<template>
  <ListingsFilterControl :label="label">
    <div class="listings-checkbox-filter-ui">
      <VCheckbox v-model="model" :disabled="disabled" class="listings-filter" />
      <VTooltip class="top">
        <p class="listings-checkbox-filter-ui__tooltip-text">
          {{ explanation }}
        </p>
        <template #activator="{ attrs, on }">
          <div class="listings-checkbox-filter-ui__activator">
            <VFallbackText v-bind="attrs" class="hint" v-on="on">
              What does this mean?
            </VFallbackText>
          </div>
        </template>
      </VTooltip>
    </div>
  </ListingsFilterControl>
</template>

<script lang="ts" setup>
  // Types
  import type { TBooleanFilterEvent } from '~/misc/listings/filters/checkbox/types';

  // Utils
  import { eventBus } from '~/misc/utils/event-bus';

  // Components
  import ListingsFilterControl from '~/misc/listings/filters/control/ListingsFilterControl.vue';
  import VCheckbox from '~/misc/v-checkbox';
  import VFallbackText from '~/misc/v-fallback-text/VFallbackText.vue';
  import VTooltip from '~/misc/v-tooltip/VTooltip.vue';

  const props = defineProps({
    explanation: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    analyticsEvent: {
      type: String as PropType<TBooleanFilterEvent>,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const model = defineModel({
    type: Boolean,
    required: true,
  });

  watch(
    model,
    (value: boolean) => {
      if (!props.analyticsEvent) return;

      eventBus.emit(props.analyticsEvent, { value });
    },
    { immediate: true }
  );
</script>
